import React, { useMemo, useCallback } from "react";
import { Alert, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { removeMessage } from "redux-flash";

const FlashMessage = () => {
  const dispatch = useDispatch();
  const flashMessages = useSelector((state) => state.flashMessages);

  const messages = useMemo(() => flashMessages || [], [flashMessages]);

  const handleDismiss = useCallback(
    (id) => {
      dispatch(removeMessage(id));
    },
    [dispatch],
  );

  if (messages.length === 0) return null;

  return (
    <Container>
      {messages.map(
        ({ id, message, isError, props: { alertStyle, title } }) => (
          <Alert
            key={id}
            variant={isError ? "danger" : alertStyle || "success"}
            dismissible
            onClose={() => handleDismiss(id)}
          >
            {title && <h4>{title}</h4>}
            <p>{message}</p>
          </Alert>
        ),
      )}
    </Container>
  );
};

export default FlashMessage;
